export default __webpack_public_path__ + "static/media/028z.a8bd45d6.jpg";